import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogInputModel } from 'countable@model';
import { DIALOG_TYPES } from 'countable@helpers';
import { CoreModule } from 'src/app/core/core.module';

@Component({
  selector: 'app-countable-dialog',
  standalone: true,
  imports: [CommonModule, SharedModule, ReactiveFormsModule, CoreModule],
  templateUrl: './countable-dialog.component.html',
  styleUrl: './countable-dialog.component.scss'
})
export class CountableDialogComponent implements OnInit {

  dialogType: DIALOG_TYPES = null;
  dialogHeader: string;
  dialogData: any;

  constructor(public dialogRef: MatDialogRef<CountableDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogInputModel) {

  }

  ngOnInit(): void {
    this.dialogData = this.data.data;
    this.dialogHeader = this.data.dialogHeader;
    this.dialogType = this.data.dialogType;
  }

}
